var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFooterLogoTablet = function SvgFooterLogoTablet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 23,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.835 17.308v-3.094h2.33a3.095 3.095 0 1 0 0-6.187h-3.099v6.188l-3.098 3.093h-5.429v-3.094h5.429V4.922h6.209c3.425 0 6.209 2.78 6.209 6.199s-2.784 6.199-6.21 6.199zM45.75 6.469l-3.1 3.093v4.653h-2.33V4.922h-6.209c-3.424 0-6.209 2.78-6.209 6.199v6.199h5.417l3.122-3.094h-5.428V11.11a3.095 3.095 0 0 1 3.098-3.093h3.1v9.292h5.428l3.11-3.094zM1.527 5.682l3.098 3.093h5.429v2.326H6.967c-3.425 0-6.21 2.78-6.21 6.2v1.546h3.1V17.3a3.095 3.095 0 0 1 3.098-3.093h6.21V8.775l-3.1-3.093zM26.353 14.214l-3.1 3.094h-8.526V4.922l3.098-3.106v12.398zM44.198 4.92a1.547 1.547 0 1 0 0-3.094c-.862 0-1.55.698-1.55 1.547s.7 1.547 1.55 1.547M21.706 21.957a1.547 1.547 0 1 0 0-3.094 1.547 1.547 0 1 0 0 3.094M3.854 4.139a1.547 1.547 0 1 0 0-3.094c-.862 0-1.55.698-1.55 1.547s.7 1.547 1.55 1.547"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#footerLogoTablet_svg__a)",
    d: "m96.558 22.043 4.694-4.687v-7.141c0-5.118-4.147-9.258-9.273-9.258H79.445L74.75 5.644h21.808z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#footerLogoTablet_svg__b)",
    d: "M96.556 5.644A4.684 4.684 0 0 0 91.86.957h-7.56v4.687z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#footerLogoTablet_svg__c)",
    d: "m73.081.957-4.694 4.687v7.141c0 5.117 4.147 9.258 9.273 9.258h12.534l4.695-4.687H73.081z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#footerLogoTablet_svg__d)",
    d: "M73.082 17.352a4.685 4.685 0 0 0 4.695 4.687h4.95v-4.687z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m86.803 10.873-3.18-1.837a.73.73 0 0 0-1.096.628v3.663a.73.73 0 0 0 1.095.628l3.18-1.814a.731.731 0 0 0 0-1.268"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "footerLogoTablet_svg__a",
    x1: 85.567,
    x2: 94.17,
    y1: 15.71,
    y2: 0.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#B21F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#711010"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "footerLogoTablet_svg__b",
    x1: 84.3,
    x2: 96.557,
    y1: 3.3,
    y2: 3.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "red",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#C60000",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397,
    stopColor: "maroon",
    stopOpacity: 0.397
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.602,
    stopColor: "#490000",
    stopOpacity: 0.602
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    stopColor: "#210000",
    stopOpacity: 0.776
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915,
    stopColor: "#090000",
    stopOpacity: 0.915
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "footerLogoTablet_svg__c",
    x1: 75.453,
    x2: 84.056,
    y1: 22.205,
    y2: 7.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#B21F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#FF6D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893,
    stopColor: "#FF7E76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961,
    stopColor: "#FF9893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA29E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "footerLogoTablet_svg__d",
    x1: 73.086,
    x2: 82.735,
    y1: 19.698,
    y2: 19.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.085,
    stopColor: "#090000",
    stopOpacity: 0.915
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224,
    stopColor: "#210000",
    stopOpacity: 0.776
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#490000",
    stopOpacity: 0.602
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.603,
    stopColor: "maroon",
    stopOpacity: 0.397
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#C60000",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "red",
    stopOpacity: 0
  })))));
};
export default SvgFooterLogoTablet;